import { render, staticRenderFns } from "./list-cwo.vue?vue&type=template&id=4bd3c018&"
import script from "./list-cwo.vue?vue&type=script&lang=js&"
export * from "./list-cwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports